import { ComumService } from '../../comum/comum.service';
import { Endereco } from '../../comum/modelos/endereco';
import { PontoFisico } from '../../comum/modelos/ponto-fisico';
import { RegiaoCliente } from '../../comum/modelos/regiao-cliente';
import { Usuario } from '../../comum/modelos/usuario';
import { RegiaoService } from '../../regiao/regiao.service';
import { UsuarioService } from '../../usuario/usuario.service';
import { PontoFisicoService } from '../ponto-fisico.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { EnderecoPontoFisico } from '../../comum/modelos/endereco-ponto-fisico';
import { TipoPontoFisico } from '../../comum/modelos/tipo-ponto-fisico';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';
import { AreaCliente } from '../../comum/modelos/area-cliente';
import { ClienteService } from '../../cliente/cliente.service';

@Component({
    selector: 'app-cad-ponto-fisico',
    templateUrl: './cadastro-ponto-fisico.component.html',
    styleUrls: ['./cadastro-ponto-fisico.component.css']
})
export class CadastroPontoFisicoComponent implements OnInit {

    public pontoFisico: PontoFisico;

    public cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    public usuarios: Usuario[];
    public regioesCliente: RegiaoCliente[];
    public areasCliente: AreaCliente[];
    public tiposPontoFisico: TipoPontoFisico[];
    public endereco: Endereco;
    public foto: File;
    public loading = false;
    MODO: string;
    CADASTRAR = 'Cadastrar';
    ATUALIZAR = 'Atualizar';
    statusCode: number;

    constructor (private _usuarioService: UsuarioService,
        private _pontoFisicoService: PontoFisicoService,
        private _regiaoService: RegiaoService,
        private _clienteService: ClienteService,
        private _comumService: ComumService,
        private _activatedRoute: ActivatedRoute,
        private router: Router,
        private _cookieService: CookieService,
        private _authService: AuthService) {
        this.pontoFisico = new PontoFisico();
        this.usuarios = new Array<Usuario>();
        this.regioesCliente = new Array<RegiaoCliente>();
        this.areasCliente = new Array<AreaCliente>();
        this.tiposPontoFisico = new Array<TipoPontoFisico>();
    }

    ngOnInit() {
        this.loading = true;
        const idCliente = parseInt(this._cookieService.get('idCliente'), 10);
        this.pontoFisico.idCliente = idCliente;
        const u = this._usuarioService.obterUsuariosHttp(idCliente);
        const rc = this._regiaoService.obterRegioesClienteHttp(idCliente);
        const tpf = this._pontoFisicoService.obterTiposPontosFisicoHttp(idCliente);
        const ac = this._clienteService.obterAreasClienteHttp(idCliente);
        const id = this._activatedRoute.snapshot.params['id'];

        if (id !== undefined) {
            forkJoin(u, rc, this._pontoFisicoService.obterPontoFisicoPorIdHttp(id), tpf, ac)
                .subscribe(([usuarios, regioesCliente, pontoFisico, tiposPontoFisico, areasCliente]) => {
                    this.pontoFisico = pontoFisico;
                    this.regioesCliente = regioesCliente;
                    this.tiposPontoFisico = tiposPontoFisico;
                    this.areasCliente = areasCliente;
                    this.usuarios = usuarios;
                    if (pontoFisico.enderecoPontoFisico.endereco.idEndereco !== undefined
                        && pontoFisico.enderecoPontoFisico.endereco.idEndereco !== null) {
                        this.endereco = pontoFisico.enderecoPontoFisico.endereco;
                        this.pontoFisico.enderecoPontoFisico.selecionado = true;
                    } else {
                        this.endereco = undefined;
                    }
                    this.loading = false;
                    this.MODO = this.ATUALIZAR;
                });
        } else {
            forkJoin(u, rc, tpf, ac)
                .subscribe(([usuarios, regioesCliente, tiposPontoFisico, areasCliente]) => {
                    this.usuarios = usuarios;
                    this.regioesCliente = regioesCliente;
                    this.tiposPontoFisico = tiposPontoFisico;
                    this.areasCliente = areasCliente;
                    this.loading = false;
                    this.endereco = undefined;
                    this.MODO = this.CADASTRAR;
                });
        }
    }

    receberEndereco(enderecoParam: Endereco) {
        this.endereco = enderecoParam;
        const enderecoPontoFisico = new EnderecoPontoFisico(enderecoParam);
        this.pontoFisico.enderecoPontoFisico = enderecoPontoFisico;
        this.pontoFisico.enderecoPontoFisico.selecionado = true;
    }

    atualizarEndereco(enderecoParam: Endereco) {
        this.endereco = enderecoParam;
        this.pontoFisico.enderecoPontoFisico.endereco = enderecoParam;
        this.pontoFisico.enderecoPontoFisico.selecionado = true;
    }

    removerEnderecoPontoFisico(): void {
        this.pontoFisico.enderecoPontoFisico.selecionado = false;
        this.endereco = undefined;
    }

    onSubmit(): void {
        this.loading = true;
        const self = this;

        if (self.MODO === this.CADASTRAR) {
            self._pontoFisicoService.cadastrarPontoFisicoHttp(self.pontoFisico, self.foto)
                .subscribe(response => {
                    self.loading = false;
                    self.statusCode = response.status;
                    self._comumService.evento.cadastro = true;
                    self.router.navigate(['listar-ponto-fisico']);
                }, errorCode => {
                    self.statusCode = errorCode;
                    self.loading = false;
                });
        } else {
            if (this.pontoFisico.enderecoPontoFisico !== undefined) {
                if (this.pontoFisico.enderecoPontoFisico.selecionado) {
                    if (this.pontoFisico.enderecoPontoFisico.endereco.idEndereco !== undefined) {

                        this._pontoFisicoService.atualizarEnderecoPontoFisicoHttp(
                            this.pontoFisico.enderecoPontoFisico).subscribe(response => {
                            self.loading = false;
                            self.statusCode = response.status;
                            self._comumService.evento.atualizar = true;
                            self.router.navigate(['listar-ponto-fisico']);
                            console.log(response);
                        }, errorCode => {
                            self.statusCode = errorCode;
                            self.loading = false;
                        });

                    } else {
                        this.pontoFisico.enderecoPontoFisico.idPontoFisico = this.pontoFisico.idPontoFisico;
                        this._pontoFisicoService.inserirEnderecoPontoFisicoHttp(
                            this.pontoFisico.enderecoPontoFisico).subscribe(response => {
                            self.loading = false;
                            self.statusCode = response.status;
                            self._comumService.evento.atualizar = true;
                            self.router.navigate(['listar-ponto-fisico']);
                            console.log(response);
                        }, errorCode => {
                            self.statusCode = errorCode;
                            self.loading = false;
                        });

                    }
                } else {
                    if (this.pontoFisico.enderecoPontoFisico.endereco.idEndereco !== undefined
                        && this.pontoFisico.enderecoPontoFisico.endereco.idEndereco !== null) {
                        this._pontoFisicoService.removerEnderecoPontoFisicoHttp(
                            this.pontoFisico.enderecoPontoFisico).subscribe(response => {
                            self.loading = false;
                            self.statusCode = response.status;
                            self._comumService.evento.atualizar = true;
                            self.router.navigate(['listar-ponto-fisico']);
                            console.log(response);
                        }, errorCode => {
                            self.statusCode = errorCode;
                            self.loading = false;
                        });
                    }
                }
            }
            self._pontoFisicoService.atualizarPontoFisicoHttp(self.pontoFisico, self.foto)
                .subscribe(response => {
                    self.loading = false;
                    self.statusCode = response.status;
                    self._comumService.evento.atualizar = true;
                    self.router.navigate(['listar-ponto-fisico']);
                    console.log(response);
                }, errorCode => {
                    self.statusCode = errorCode;
                    self.loading = false;
                });
        }
    }

    onFileChanged(event) {
        this.foto = event.target.files[0];
    }

    receberTipoPontoFisico(tipoPontoFisico: TipoPontoFisico) {
        this.tiposPontoFisico.push(tipoPontoFisico);
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ponto-fisico/cadastro-ponto-fisico/cadastro-ponto-fisico.component.ts